import { createSelector } from "reselect";

const getStory = (state) => state.story;

// This creates a new selector for each source that wants one. See the "Sharing Selectors Across
// Multiple Components" section of http://redux.js.org/docs/recipes/ComputingDerivedData.html
const makeGetAllHotspotEntityDefinitions = () =>
  createSelector([getStory], (story) =>
    story.chapters.reduce((memo, chapterSchemaDefinition) => {
      const chapterEntity =
        story.entities[chapterSchemaDefinition.schema][
          chapterSchemaDefinition.id
        ];

      return [...memo, ...chapterEntity.hotspots];
    }, []),
  );

export default makeGetAllHotspotEntityDefinitions;
